<template>
  <div>
    <div class="d-flex align-items-start">
      <validation-provider
        class="w-100"
        :ref="inputId"
        :name="inputName"
        :rules="inputValidationRules"
        v-slot="validationContext">
        <b-form-group
          class="form-input-wrapper"
          :label="inputName"
          :label-for="inputId"
          :label-class="(!!model) ? 'form-label font-weight-bold filled-field-datetimepicker' : 'form-label font-weight-bold empty-field'"
          :invalid-feedback="validationContext.errors[0]"
        >
          <b-form-input
            v-if="!visible"
            v-mask="'##:##'"
            :disabled="disabled"
            :id="inputId"
            :class="{ 'form-input': true, 'filled-field': (!!model), 'required-field': (!(!!model) && required), inputId: true }"
            v-model="model"
            @blur="placeholder = inputName"
            @click="changePlaceholder"
            :placeholder="placeholder"
            @change="updateIdbData"
            @input="checkFormInputData"
            :state="getValidationState(validationContext)"
            trim
          ></b-form-input>
          <ctk-date-time-picker
            v-if="visible"
            :disabled="disabled"
            v-model="model"
            :class="{ 'form-input': true, 'filled-field': (!!model) }"
            :id="inputId"
            :label="inputName"
            :color="color"
            locale="ru"
            onlyTime
            noLabel
            format="hh:mm"
            formatted="hh:mm"
            @is-hidden="closeDateTimePicker"
            @input="updateIdbData"
            :state="getValidationState(validationContext)"
          >
          </ctk-date-time-picker>
          <span v-if="visible" class="custom-invalid-feedback">{{ validationContext.errors[0] }}</span>
        </b-form-group>
      </validation-provider>
    </div>
  </div>
</template>

<script>
  import CtkDateTimePicker from 'vue-ctk-date-time-picker'
  import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
  import { simulateEventMixin } from './mixins/simulateEventMixin'
  // import moment from 'moment'
  export default {
    name: "CustomTimePicker",
    mixins: [simulateEventMixin],
    props: {
      inputId: {
        default: null,
        type: String
      },
      inputName: {
        default: null,
        type: String
      },
      inputValidationRules: {
        default: null,
        type: Object
      },
      disabled: {
        default: false,
        type: Boolean
      },
      required: {
        default: false,
        type: Boolean
      },
      index: {
        default: null,
        type: Number
      },
      parent: {
        default: null,
        type: String
      },
      color: {
        default: '#40b539',
        type: String
      }
    },
    components: {
      CtkDateTimePicker
    },
    data () {
      return {
        model: null,
        targetInput: null,
        visible: false,
        placeholder: null,
      }
    },
    watch: {
    },
    mounted () {
      this.placeholder = this.inputName
    },
    methods: {
      toggleDateTimePicker () {
        this.visible = !this.visible
        setTimeout(() => {
          if (this.visible === true) {
            this.simulate(document.getElementById(this.inputId + '-input'), "click")
          }
        }, 100)
      },
      closeDateTimePicker () {
        this.visible = false
        this.checkFormInputData()
      },
      checkFormInputData () {
        this.$nextTick(() => {
          if (this.model === '') {
            this.model = null
            this.$emit('updateIdbData')
          }
        })
      },
      getValidationState ({ dirty, validated, valid = null }) {
        return dirty || validated ? valid : null
      },
      changePlaceholder () {
        this.placeholder = '00:00'
      },
      updateIdbData () {
        console.log('updateIdbData')
        this.$nextTick(() => {
          window.dispatchEvent(new KeyboardEvent('keydown', {
            key: "escape",
            keyCode: 27,
            shiftKey: false,
            ctrlKey: false,
            metaKey: false
          }))
          if (this.model) {
            this.$emit('setForm', { fieldName: this.inputId, item: this.model, index: this.index, parent: this.parent })
          }
        })
      },
    }
  }
</script>

<style scoped>

</style>
